import { render, staticRenderFns } from "./EmployeeBadgeHolderList.vue?vue&type=template&id=7ef1edd4&scoped=true"
import script from "./EmployeeBadgeHolderList.vue?vue&type=script&lang=js"
export * from "./EmployeeBadgeHolderList.vue?vue&type=script&lang=js"
import style0 from "./EmployeeBadgeHolderList.vue?vue&type=style&index=0&id=7ef1edd4&prod&lang=css"
import style1 from "./EmployeeBadgeHolderList.vue?vue&type=style&index=1&id=7ef1edd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef1edd4",
  null
  
)

export default component.exports